import { FC, SVGAttributes } from 'react';

const Checkmark: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1266 4.5951C19.626 4.9409 19.7506 5.62615 19.4048 6.12564L10.5937 18.8528C10.0828 19.5908 9.00732 19.6339 8.43893 18.9392L4.14907 13.6961C3.76437 13.2259 3.83367 12.5329 4.30386 12.1482C4.77405 11.7635 5.46708 11.8328 5.85178 12.303L9.42715 16.6729L17.596 4.87338C17.9418 4.37389 18.6271 4.2493 19.1266 4.5951Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Checkmark;
